import { render } from "./ButtonGupUploads.vue?vue&type=template&id=649524d7&scoped=true"
import script from "./ButtonGupUploads.vue?vue&type=script&lang=js"
export * from "./ButtonGupUploads.vue?vue&type=script&lang=js"

import "./ButtonGupUploads.vue?vue&type=style&index=0&id=649524d7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649524d7"]])

export default __exports__